import React from "react";
import String from "./String.js";

export default ({appId, color}) => <String color={color} str={`${(appId ? "App ID: " : "")}${(process.env.REACT_APP_APP || "(Undefined)")}`} />;
